import { inject, IEventAggregator, bindable } from "aurelia";
import { getLogger } from "../../common/logging";
import { CurrentRoute } from "../../current-route";
import { FormFieldChanged } from "../../messages/form-field-changed";
import { ApplicationService } from "../../services/application-service";
import { elementId } from "../../common/element-id";
import { afterSiblingsBound, fieldOf } from "../../common/element-field";

let log = getLogger("applicant-name");

@inject(Element, IEventAggregator, ApplicationService, CurrentRoute)
export class ApplicantNameCustomAttribute {
  @bindable value;

  constructor(element, eventAggregator, applicationService, currentRoute) {
    this.element = element;
    this.eventAggregator = eventAggregator;
    this.applicationService = applicationService;
    this.currentRoute = currentRoute;
    this.fields = [];
  }

  attached() {
    this.elementId = elementId(this.element);
    this.applicationId = this.currentRoute.params.id;
    this.subscription = this.eventAggregator.subscribe(
      FormFieldChanged,
      (message) => {
        this.onFormFieldChanged(message);
      }
    );

    if (this.value) {
      this.fields = this.value.split(" ");
    }

    if (this.fields.length === 0) {
      afterSiblingsBound(() => this.addFieldOfElement());
    }
  }

  addFieldOfElement() {
    const field = fieldOf(this.element);
    if (field === undefined) return;

    this.fields.push(field.name);
  }

  detaching() {
    this.subscription.dispose();
  }

  onFormFieldChanged(message) {
    if (message.elementId !== this.elementId || !this.applicationId) return;

    let name = "";
    let divider = "";

    for (let f of this.fields) {
      let v = this.$controller.scope.bindingContext.form[f];
      if (v === undefined) continue;
      name += divider + v;
      divider = " ";
    }

    this.applicationService.setApplicantName(this.applicationId, name);
  }
}
